export const ADMIN_ROLE_ACCESS = ["ADMIN", "ADMIN_USER"]
export const ADMIN = "ADMIN"
export const ADMIN_USER = "ADMIN_USER"